import UpdateContactDetails from './UpdateContactDetails';
export default UpdateContactDetails;